import { render, staticRenderFns } from "./AchievementRecord.vue?vue&type=template&id=695c94da&scoped=true&"
import script from "./AchievementRecord.vue?vue&type=script&lang=js&"
export * from "./AchievementRecord.vue?vue&type=script&lang=js&"
import style0 from "./AchievementRecord.vue?vue&type=style&index=0&id=695c94da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695c94da",
  null
  
)

export default component.exports